export const toggleMaxHeight = (element: HTMLElement) => {
    if(
        !(element.style.maxHeight) ||
        element.style.maxHeight === '0px'
    ) {
        element.style.maxHeight = `${element.scrollHeight}px`;
    } else {
        element.style.maxHeight = `0px`;
    }
}